var Tradename;
(function (Tradename) {
    Tradename["LOOKIERO"] = "LOOKIERO";
    Tradename["OUTFITTERY"] = "OUTFITTERY";
})(Tradename || (Tradename = {}));
export { Tradename };
